import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _toArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import { Notification, Message } from 'element-ui';
export default (function (context) {
  var optionsEnv = Object.keys(context.env).filter(function (keyName) {
    return /^VUE_APP_API_\d+_\w+$/.test(keyName);
  }).map(function (keyName) {
    var _keyName$replace$spli = keyName.replace('VUE_APP_API_', '').split('_'),
        _keyName$replace$spli2 = _toArray(_keyName$replace$spli),
        index = _keyName$replace$spli2[0],
        name = _keyName$replace$spli2.slice(1);

    return {
      index: Number(index),
      name: name.join('_'),
      value: context.env[keyName]
    };
  }).sort(function (a, b) {
    return a.index - b.index;
  }).map(function (e) {
    return {
      name: e.name,
      value: e.value,
      type: 'env'
    };
  });
  var base = context.env.VUE_APP_API || (optionsEnv.length > 0 ? optionsEnv[0].value : '');
  return {
    namespaced: true,
    state: {
      // 网络请求地址
      base: base,
      // env 中设置的地址选项
      optionsEnv: optionsEnv,
      // 用户自己添加的地址
      optionsUser: []
    },
    getters: {
      // 混合系统提供的地址和用户自己设置的地址记录
      options: function options(state) {
        return [].concat(_toConsumableArray(state.optionsUser), _toConsumableArray(state.optionsEnv));
      }
    },
    actions: {
      /**
       * @description 改变网络请求地址
       * @param {Object} vuex context
       * @param {String} value
       */
      set: function set(_ref, value) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var state, dispatch, findIndex;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  state = _ref.state, dispatch = _ref.dispatch;

                  if (!(state.base === value)) {
                    _context.next = 3;
                    break;
                  }

                  return _context.abrupt("return");

                case 3:
                  // 如果不是选项中的值 将其加入选项
                  findIndex = [].concat(_toConsumableArray(state.optionsEnv), _toConsumableArray(state.optionsUser)).map(function (e) {
                    return e.value;
                  }).indexOf(value);

                  if (!(findIndex === -1)) {
                    _context.next = 8;
                    break;
                  }

                  state.optionsUser.push({
                    name: '自定义',
                    value: value,
                    type: 'custom'
                  }); // 持久化用户自定义选项

                  _context.next = 8;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'api.optionsUser',
                    value: state.optionsUser,
                    user: false
                  }, {
                    root: true
                  });

                case 8:
                  // 注销当前登录
                  dispatch('d2admin/user/logout', {
                    focus: true,
                    remote: false,
                    back: true
                  }, {
                    root: true
                  }); // 应用变更

                  state.base = value; // 持久化接口地址设置

                  _context.next = 12;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'api.base',
                    value: state.base,
                    user: false
                  }, {
                    root: true
                  });

                case 12:
                  // 显示提示
                  Notification({
                    title: '接口地址变更',
                    message: value
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },

      /**
       * @description 删除一个用户自己的地址配置
       * @param {Object} vuex context
       * @param {String} value
       */
      remove: function remove(_ref2, value) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var state, dispatch, index;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  state = _ref2.state, dispatch = _ref2.dispatch;
                  index = state.optionsUser.map(function (e) {
                    return e.value;
                  }).indexOf(value);

                  if (!(index >= 0)) {
                    _context2.next = 7;
                    break;
                  }

                  // 移除
                  state.optionsUser.splice(index, 1); // 持久化用户自定义选项

                  _context2.next = 6;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'api.optionsUser',
                    value: state.optionsUser,
                    user: false
                  }, {
                    root: true
                  });

                case 6:
                  // 显示提示
                  Message({
                    message: "".concat(value, " \u5DF2\u7ECF\u5220\u9664"),
                    type: 'success'
                  });

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      },

      /**
       * @description 加载设置
       * @param {Object} vuex context
       */
      load: function load(_ref3) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var state, dispatch;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  state = _ref3.state, dispatch = _ref3.dispatch;
                  _context3.next = 3;
                  return dispatch('d2admin/db/get', {
                    dbName: 'sys',
                    path: 'api.base',
                    defaultValue: base,
                    user: false
                  }, {
                    root: true
                  });

                case 3:
                  state.base = _context3.sent;
                  _context3.next = 6;
                  return dispatch('d2admin/db/get', {
                    dbName: 'sys',
                    path: 'api.optionsUser',
                    defaultValue: [],
                    user: false
                  }, {
                    root: true
                  });

                case 6:
                  state.optionsUser = _context3.sent;

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      }
    }
  };
});